export interface ICaseAppointmentStatusOption {
  id: string
  name: string
}

export class CaseAppointmentStatusOption implements ICaseAppointmentStatusOption {
  public id: string
  public name: string

  constructor(id: string, name: string) {
    this.id = id
    this.name = name
  }
}

export const caseAppointmentStatusOptions: CaseAppointmentStatusOption[] = [
  new CaseAppointmentStatusOption('1', 'Active'),
  new CaseAppointmentStatusOption('2', 'Cancelled'),
  new CaseAppointmentStatusOption('3', 'Completed'),
  new CaseAppointmentStatusOption('4', 'No Show'),
  new CaseAppointmentStatusOption('5', 'Postponed'),
  new CaseAppointmentStatusOption('6', 'Rescheduled'),
]
